//tasks-day-package-section.tsx

import { Box, Typography } from "@mui/material";
import TaskGrid from "../task-grid";
import { PackageTaskRow } from "../../types/task-rows";
import { Tasks } from "../../models/tasks";

interface TasksDayPackageSectionProps {
  rows: PackageTaskRow[];
  packageColumns: any;
  packageColumnOptions: any;
  periodTasksTag?: number;
  periodTasks: Tasks[];
  title: string;
}

export default function TasksDayPackageSection({
  rows,
  packageColumns,
  packageColumnOptions,
  periodTasksTag,
  periodTasks,
  title,
}: TasksDayPackageSectionProps) {
  return (
    <Box>
      <Typography
        variant="h4"
        color="primary"
        sx={{
          pt: 4,
          display: "flex",
          alignItems: "end",
          justifyContent: "space-between",
        }}
      >
        {title}
      </Typography>

      <TaskGrid
        key={periodTasksTag}
        taskKey="package"
        rows={rows}
        baseColumns={packageColumns}
        columnOptions={packageColumnOptions}
      />
    </Box>
  );
}
